import { Theme, themeAtom } from "atoms/app.atom"
import { useStore } from "hooks"
import { useCallback } from "react"
import { useSetAtom } from "jotai"
import { session } from "store"

export const useChangeTheme = () => {
  const { user, updateProfile } = useStore(session)
  const setTheme = useSetAtom(themeAtom)

  const changeTheme = useCallback(
    (theme: Theme) => {
      setTheme(theme)
      ;(window as any)?.ReactNativeWebView?.postMessage?.(
        JSON.stringify({
          type: "theme",
          data: theme,
        }),
      )

      updateProfile(
        {
          preferences: {
            ...user.preferences,
            theme,
          },
        },
        {
          saveBefore: true,
        },
      )
    },
    [setTheme, updateProfile, user.preferences],
  )

  return { changeTheme }
}
